/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

// Remember, this is supposed to cover the 'easy' majority of field code.
// Don't make this overly complex just to accomodate a few fields with special behaviour

import ko from "knockout";
import _ from "underscore";

// Register all the field templates
_.each({
	"field-label-checkbox": require("../../../templates/shared/field/label-checkbox.html"),
	"field-label": require("../../../templates/shared/field/label.html"),
	"field-options-multiselect-searchable": require("../../../templates/shared/field/options-multiselect-searchable.html"),
	"field-options": require("../../../templates/shared/field/options.html"),
	"field-options-radio": require("../../../templates/shared/field/options-radio.html"),
	"field-options-checkbox": require("../../../templates/shared/field/options-checkbox.html"),
	"field-options-checkbox-images": require("../../../templates/shared/field/options-checkbox-images.html"),
	"field-options-searchable": require("../../../templates/shared/field/options-searchable.html"),
	"field-options-with-other": require("../../../templates/shared/field/options-with-other.html"),
	"field-boolean-menu": require("../../../templates/shared/field/boolean-menu.html"),
	"field-boolean-radio": require("../../../templates/shared/field/boolean-radio.html"),
	"field-text": require("../../../templates/shared/field/text.html"),
	"field-textarea": require("../../../templates/shared/field/textarea.html"),
	"field-number": require("../../../templates/shared/field/number.html"),
	"field-integer": require("../../../templates/shared/field/integer.html"),
	"field-multi-text": require("../../../templates/shared/field/multi-text.html"),
	"field-local-time": require("../../../templates/shared/field/local-time.html"),
	"field-media": require("../../../templates/shared/field/media.html")
}, function(v, k) {
	ko.components.register(k, { template: v });
});

function labelTemplate(field) {
	if(field.type === 'boolean' && field.style !== 'radio' && !field.allowNull) {
		return "field-label-checkbox";
	} else {
		return "field-label";
	}
}

function fieldTemplate(field) {
	switch(field.type) {
	case 'options':
		if(field.style === 'radio') {
			return "field-options-radio";
		} else if(field.multiselect) {
			if(field.optionImages) {
				return "field-options-checkbox-images";
			} else if(field.style === 'checkbox') {
				return "field-options-checkbox";
			} else {
				return "field-options-multiselect-searchable";
			}
		} else if(field.searchable) {
			return "field-options-searchable";
		} else {
			return "field-options";
		}
	case 'boolean':
		if(field.style === 'radio') {
			return "field-boolean-radio";
		} else if(field.allowNull) {
			return "field-boolean-menu";
		} else {
			return "";
		}
	case 'text':
		if(field.multiline) {
			return "field-textarea";
		} else if(field.options) {
			return "field-options-with-other";
		} else {
			return "field-text";
		}
	case 'number':
		return "field-number";
	case 'integer':
		return "field-integer";
	case 'multi-text':
		return "field-multi-text";
	case 'local-time':
		return "field-local-time";
	case 'media':
		return "field-media";
	default:
		return "";
	}
}

ko.components.register('field', {
	viewModel: function(params) {
		params = params || {};
		var field = this.field = params.value.field;
		this.inputClasses = { 'has-units': !!field.units };
		this.fieldClasses = 'field field-' + field.name + ' field-type-' + field.type;
		this.labelTextClasses = ko.pureComputed(() => ({ required: ko.unwrap(field.required) }));
		this.labelTemplate = params.hideLabel ? null : labelTemplate(field);
		this.fieldTemplate = fieldTemplate(field);
		this.disabled = ko.pureComputed(() => field.disabled && field.disabled());
		if(field.maxLength) {
			this.maxLength = field.maxLength;
		} else if(field.type == 'integer' && field.max) {
			this.maxLength = Math.ceil(Math.log10(field.max));
		} else if(field.type == 'number' && field.max && field.decimalPlaces) {
			let negativeAllowed = (field.min ?? -1) < 0
			this.maxLength = Math.ceil(Math.log10(field.max)) + field.decimalPlaces + 1 + (negativeAllowed ? 1 : 0);
		} else {
			this.maxLength = null;
		}

		this.placeholder = field.placeholder;
		this.hidden = field.hidden || ko.observable(false);
		this.optionsText = params.optionsText || 'name';

		if(field.type === 'boolean') {
			const labels = field.optionLabels || [];
			this.trueLabel = labels[0] || 'Yes';
			this.falseLabel = labels[1] || 'No';
			this.nullLabel = labels[2] || (field.allowNull ? 'N/A' : 'Select…');
		}

		if(field.type === 'local-time') {
			this.localTimeHours = ko.pureComputed({
				read: function() {
					let parts = (field.value() || "").split(":");
					return parts[0];
				},
				write: function(x) {
					let parts = (field.value() || "").split(":");
					parts[0] = x;
					if(parts.length == 1) {
						parts[1] = '00'; // Auto set minutes
					}
					field.value(parts.join(":"));
				}
			});
			this.localTimeMinutes = ko.pureComputed({
				read: function() {
					let parts = (field.value() || "").split(":");
					return parts[1];
				},
				write: function(x) {
					let parts = (field.value() || "").split(":");
					parts[1] = x;
					if(!parts[0]) {
						parts[0] = '0';
					}
					field.value(parts.join(":"));
				}
			});
		}
	},
	template: require('../../../templates/shared/field.html')
});

/* Global helper to view images */
window.showImageModal = function(src) {
	var container = document.createElement('div');
	var img = document.createElement('img');
	var close = document.createElement('div');
	container.appendChild(img);
	container.appendChild(close);

	container.setAttribute('class', 'image-modal');
	img.src = src;
	close.setAttribute('class', 'close');
	close.textContent = "Close";

	close.addEventListener('click', function() {
		container.remove();
	})

	document.body.appendChild(container);
}
